import React, { Component } from "react";
import { Modal, Row, Col, Button, ListGroup, Form, InputGroup  } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import SLMAgencyModal from "containers/slm/SLMAgencyModal"; //new
import Amplify, { Auth } from "aws-amplify";
//import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SLMEntityLinkList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            agencies: [],
            filter: {},
            showAgentDialog: false,
            showAlert: false,
            editedAgencies: [],
            dataSet: "entityLinks",
            dataRecord: "entityLink",
            dataSetPrimaryKey: "entity_link_id",
            newRecordIndex: 0,
            agencySearchString: null,
            agencyInterstateFlag: true,
            selectedAgency: null,
            selectedAgent: null,
            agencyOptions: [], 
            agentOptions: [],
            agencyMenuIsOpen: false,
            entity_org_id: null,
            agency_name: null,
            agency_phone: null,
            agency_phone_ext: null,
            agency_phone_no: null,
            agency_suburb: null,
            agency_state: null,
            agency_postcode: null,
            entity_person_id: null,
            agent_phone: null,
            agent_email: null,
            tableRows: this.props.data.length

        };

        this.toggleAgentModal = this.toggleAgentModal.bind(this);
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        console.log("In SLMEntityLinkList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        

       
        //if (this.props.passBackMainAddress) {
            
        //    if (this.state.addresses.length > 0) {
        //        this.props.buildAddress(this.state.addresses[0]);
        //    }
        //};

        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps) {
        console.log("ComponentDidUpdate");


       
    }

    //async componentDidUpdate(prevProps) {

    //    if (this.props.passBackMainAddress != prevProps.passBackMainAddress ) {
    //      if (this.state.addresses.length > 0) {
    //            var i;
    //          for (i = 0; i < this.state.addresses.length; i++) {
    //            if (this.state.addresses[i].main_address === true) {
    //                    this.props.buildAddress(this.state.addresses[i]);
    //                    return;
    //              }
      
    //           }
                
    //        }
    //        this.props.buildAddress({});
    //    };
       
//}



 

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete entity link");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
                this.props.updateAgencyFields();
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async () => {
    
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        
        
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleEditRecord  = async (cellInfo, event)=> {
        console.log(cellInfo);
        const agentOptions = await this.props.getAgents({ orgid: cellInfo.original.entity_org_id });
        this.setState({
            showAgentDialog: !this.state.showAgentDialog,
            newRecordIndex: cellInfo.index
            ,selectedAgent: { value: cellInfo.original.entity_person_id, label: cellInfo.original.agent_name }  
            ,selectedAgency: { value: cellInfo.original.entity_org_id, label: cellInfo.original.name }            
            ,agency_name: cellInfo.original.name
            ,entity_link_id: cellInfo.original.entity_link_id
            ,entity_org_id: cellInfo.original.entity_org_id
            ,agency_phone: (cellInfo.original.phone_ext||"")+" "+(cellInfo.original.phone_no||" ")
            ,agency_phone_ext: cellInfo.original.phone_ext
            ,agency_phone_no: cellInfo.original.phone_no
            ,agency_suburb: cellInfo.original.mail_suburb
            ,agency_state: cellInfo.original.mail_state
            ,agency_postcode: cellInfo.original.mail_code
            ,entity_person_id: cellInfo.original.entity_person_id
            ,agent_phone: cellInfo.original.agent_phone
            ,agent_email: cellInfo.original.agent_email   
            ,agentOptions: agentOptions
        });
        console.log(cellInfo);
    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({

            entity_org_id: null ,
            entity_person_id: null  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,
            lease_id: this.props.lease_id? this.props.lease_id: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true            
        });

        this.setState({
            showAgentDialog: !this.state.showAgentDialog,
            newRecordIndex: data.length-1
        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    addAnotherRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({

            entity_org_id: null ,
            entity_person_id: null  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,
            lease_id: this.props.lease_id? this.props.lease_id: null,
            name: null ,
            phone_no: "" ,            
            phone_ext: "" ,            
            mail_suburb: "" ,
            mail_state: "" ,
            mail_code: "" ,
            agent_name: "" ,
            agent_phone: ""  ,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true            
        });

        this.setState({    
            selectedAgency: {value: null, label: null},
            selectedAgent: {value: null, label: null},
            name: null ,
            phone_no: "" ,            
            phone_ext: "" ,            
            agency_suburb: "" ,
            agency_state: "" ,
            agency_postcode: "" ,
            agency_phone: "",
            agency_email: "",

            agent_name: "" ,
            agent_phone: ""  ,     
            agent_email: ""  ,       
            newRecordIndex: data.length-1
        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    addContactRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            entity_org_id: this.state.entity_org_id ,
            entity_person_id: null  ,
            value: this.state.entity_org_id  , 
            label: this.state.agency_name  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,   
            lease_id: this.props.lease_id? this.props.lease_id: null,           
            name: this.state.agency_name ,
            phone_no: this.state.agency_phone_no ,            
            phone_ext: this.state.agency_phone_ext ,            
            mail_suburb: this.state.agency_suburb ,
            mail_state: this.state.agency_state ,
            mail_code: this.state.agency_postcode ,
            agent_name: null ,
            agent_phone: null  ,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true         
            
            

        });

        this.setState({
                        entity_person_id: null,
                        agent_phone: "",
                        agent_email: "",
                        newRecordIndex: data.length-1,
                        selectedAgent: {label: null, value: null}
                    });
        this.props.updateTableState(data, this.state.dataSet);
    }



    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

            case "number":
                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue}

                    />
                );

            default:
                if (cellInfo.column.id.indexOf("date") >= 0) {
                    return (
                        <DatePicker
                            selected={new Date(cellValue)}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                        />);
                }
                else if (cellInfo.column.id === "name" && cellValue === "") {
                    return (
                        <Select
                            value={cellValue} //UPDATE
                            onChange={this.handleagencyChange} //UPDATE
                            options={this.props.agencyOptions}

                        />);
                }
                else {
                    return (
                        <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue}

                        />
                    );
                }

        }
    }

    


    renderTable(data) {
        const columns = [

            {
                id: 'entity_org_id',
                Header: 'Agency ID',
                accessor: 'entity_org_id',
                Cell: e => <LinkContainer to={`../slmentities/${e.value}`}><a> {e.value} </a></LinkContainer>
            },
             
            {
                id: 'name',
                Header: 'Agency',
                accessor: 'name',
                Cell: this.renderEditable
                

            },{
                id: 'mail_street',
                Header: 'Street',
                accessor: 'mail_street',
                Cell: this.renderEditable


            },
            {
                id: 'mail_suburb',
                Header: 'Suburb',
                accessor: 'mail_suburb',
                Cell: this.renderEditable

            },
            {
                id: 'mail_state',
                Header: 'State',
                accessor: 'mail_state',
                Cell: this.renderEditable

            },
            {
                id: 'mail_code',
                Header: 'Postcode',
                accessor: 'mail_code',
                Cell: this.renderEditable

            },
            {
                id: 'phone_ext',
                Header: 'Phone Ext',
                accessor: 'phone_ext',
                Cell: this.renderEditable

            },
            {
                id: 'phone_no',
                Header: 'Phone No',
                accessor: 'phone_no',
                Cell: this.renderEditable

            },
            {
                id: 'email',
                Header: 'Email',
                accessor: 'email',
                Cell: this.renderEditable

            },
            {
                id: 'web',
                Header: 'Web',
                accessor: 'web',
                Cell: this.renderEditable

            }
            ,
            {
                id: 'notes',
                Header: 'Notes',
                accessor: 'notes',
                Cell: this.renderEditable

            },{
                Header: '',
                accessor: 'entity_org_id',
                Cell: row => <button onClick={(e) => this.handleDeleteRecord(row.value,e)}>Delete</button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                />
            )
        }

    }




    toggleAgentModal = async () => {
        this.setState(state => ({
            showAgentDialog: !this.state.showAgentDialog,
            agencySearchString: "",
            agencyInterstateFlag: true,
            selectedAgency: null,
            selectedAgent: null,  
            agencyMenuIsOpen: false,
            entity_org_id: null,
            agency_phone: "",
            agency_suburb: "",
            agency_state: "",
            agency_postcode: "",
            entity_person_id: null,
            agent_phone: "",
            agent_email: ""
        }));
        let data = [...this.props.data];
        
        if (data[0].hasOwnProperty("name")) {
            console.log("performing name sort");
            data.sort(function (a, b) { 
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0; 
        });
        this.setState({tableRows: this.props.data.length+1});
        }

        if (data[0].hasOwnProperty("first_name")) {
            data.sort(function (a, b) { 
                if(a.first_name < b.first_name) { return -1; }
                if(a.first_name > b.first_name) { return 1; }
                return 0;
             });
        }
        var i;
        for(i=0;i<data.length;i++){
            if (!data[i].entity_link_id){
                data.splice(i, 1);
            }
        }
        this.props.updateTableState(data, this.state.dataSet);
        this.props.updateAgencyFields();
        

    }

    handleAgencySearch = async () => {
        try {
           
            let state = null;
            if (!this.state.agencyInterstateFlag) {
                    state = this.props.state_code;
            }
            const agencyOptions = await this.props.getAgencies({ agencyname: this.state.agencySearchString,state: state });
            console.log(agencyOptions);
            this.setState({ agencyMenuIsOpen: true, agencyOptions: agencyOptions});
        }
        catch{
            alert("Error loading proposals");
        }
    }

    handleEnterOnAgencySearch = (e) => {
        if (e.keyCode === 13) {
            this.handleAgencySearch();

        }
    }

    handleFormInputChange = event => {
        this.setState({ [event.target.id]: event.target.value });

    }

    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
             })
    }

    handleAgencyChange = async (selectedAgency) => {
        
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;
        
        if(selectedAgency){
                const agentOptions = await this.props.getAgents({ orgid: selectedAgency.value });
                this.setState({ agencyMenuIsOpen: false
                        ,selectedAgency:  selectedAgency
                        ,agentOptions: agentOptions
                        , modified: true
                        ,selectedAgent: { value: null, label: null }            
                        ,agency_name: selectedAgency.name
                        ,entity_org_id: selectedAgency.value
                        ,agency_phone: (selectedAgency.phone_ext||"")+" "+(selectedAgency.phone_no||" ")
                        ,agency_phone_ext: selectedAgency.phone_ext
                        ,agency_phone_no: selectedAgency.phone_no
                        ,agency_suburb: selectedAgency.mail_suburb
                        ,agency_state: selectedAgency.mail_state
                        ,agency_postcode: selectedAgency.mail_code
                        ,entity_person_id: null
                        ,agent_phone: ""
                        ,agent_email: ""   
                    }); 
                    data[this.state.newRecordIndex].entity_org_id = selectedAgency.entity_org_id;     
                    data[this.state.newRecordIndex].name = selectedAgency.name ;
                    data[this.state.newRecordIndex].phone_ext = selectedAgency.phone_ext ;
                    data[this.state.newRecordIndex].phone_no = selectedAgency.phone_no; 
                    data[this.state.newRecordIndex].mail_suburb = selectedAgency.mail_suburb ;
                    data[this.state.newRecordIndex].mail_state = selectedAgency.mail_state ;
                    data[this.state.newRecordIndex].mail_code = selectedAgency.mail_code;  
                    data[this.state.newRecordIndex].agent_name = null ;
                    data[this.state.newRecordIndex].agent_phone = null  ;       
                }
            else{
                this.setState({ agencyMenuIsOpen: false
                    ,selectedAgency:  { value: null, label: null }
                    ,agentOptions: []
                    , modified: true
                    ,selectedAgent: { value: null, label: null }            
                    ,entity_org_id: null
                    ,agency_name: null
                    ,agency_phone: ""
                    ,agency_phone_ext: null
                    ,agency_phone_no: null
                    ,agency_suburb: ""
                    ,agency_state: ""
                    ,agency_postcode: ""
                    ,entity_person_id: null
                    ,agent_phone: ""
                    ,agent_email: ""   
                }); 
                data[this.state.newRecordIndex].entity_org_id = null ;
                data[this.state.newRecordIndex].name = null ;
                data[this.state.newRecordIndex].phone_ext = null ;
                data[this.state.newRecordIndex].phone_no = null ;
                data[this.state.newRecordIndex].mail_suburb = null ;
                data[this.state.newRecordIndex].mail_state = null ;
                data[this.state.newRecordIndex].mail_code = null ;
                data[this.state.newRecordIndex].agent_name = null ;
                data[this.state.newRecordIndex].agent_phone = null  ;
                
                ;                
            }
            const result = this.props.updateTableState(data, this.state.dataSet);
            if (result){
                this.handleSave();
            }
            
    }


    handleAgentChange = async (selectedAgent) => {     
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;           
        if(!selectedAgent){
            this.setState({ selectedAgent: { value: null, label: null }  
                        , modified: true
                        ,entity_person_id: null
                        ,agent_phone: ""
                        ,agent_email: ""

            });
            data[this.state.newRecordIndex].entity_person_id = null; 
            data[this.state.newRecordIndex].agent_name = null ;
            data[this.state.newRecordIndex].agent_phone = null  ;
        }
        else{
            this.setState({ selectedAgent: selectedAgent
                , modified: true
                ,entity_person_id: selectedAgent.value
                ,agent_phone: (selectedAgent.phone_ext||"")+" "+(selectedAgent.phone_no||" ")
                ,agent_email: selectedAgent.email

            });
            data[this.state.newRecordIndex].entity_person_id = selectedAgent.entity_person_id; 
            data[this.state.newRecordIndex].agent_name = selectedAgent.first_name + " "  + selectedAgent.last_name ;
            data[this.state.newRecordIndex].agent_phone =  (selectedAgent.phone_ext||"")+" "+(selectedAgent.phone_no||" "); 
        }
        const result = this.props.updateTableState(data, this.state.dataSet);
            if (result){
                this.handleSave();
            }
    }




    renderTable2(data) {
        const columns = [

            {
                id: 'entity_link_id',
                Header: 'Link ID',
                maxWidth: 60,
                accessor: 'entity_link_id' ,
                Cell: row => <Button variant="link" size="sm"  onClick={(e) => this.handleEditRecord(row,e)}><div style={{"font-size": "11px"}}>{row.value}</div></Button>
            },
             
            {
                id: 'name',
                Header: 'Agency',
                accessor: 'name',
                style: { 'white-space': 'unset' },
                Cell: row => (
                    <div><Button variant="link" style={{'white-space': 'normal', 'text-align': 'left'}} size="sm" onClick={(e) =>this.handleEditRecord(row)}>{row.value}</Button> <br/>p: {row.original.phone}<br/>e: {row.original.email}<br/>i: {row.original.web}</div>
                )
            },
            // {
            //     id: 'phone_no',
            //     Header: 'Phone',        
            //     maxWidth: 120,
            //     style: { 'white-space': 'unset' } ,        
            //     accessor: d=> {
            //         return (d.phone_ext||"")+" "+(d.phone_no||"")
            //     }                
            // },
            // {
            //     id: 'mail_suburb',
            //     Header: 'Suburb/State/PC',
            //     accessor: d=> {
            //         return (d.mail_suburb||"")+" "+(d.mail_state||"")+" "+(d.mail_code||"")
            //     },
            //     style: { 'white-space': 'unset' } 
            // },
            {
                id: 'agent_name',
                Header: 'Contact Name',
                accessor: 'agent_name',
                maxWidth: 120,    
                style: { 'white-space': 'unset' } ,
                Cell: row => (
                    <div>
                        {row.value}<br/>
                        t: {row.original.agent_phone}
                    </div>
                )
            },
            // {
            //     id: 'agent_phone',
            //     Header: 'Contact Phone',
            //     maxWidth: 120,           
            //     accessor: 'agent_phone' 
            // },
            {
                Header: '',
                accessor: 'entity_link_id',
                maxWidth: 80,
                Cell: row => <Button type="button" variant="danger" size="sm" onClick={(e) => this.handleDeleteRecord(row,e)}>Remove</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <div>
                <Modal
                    show={this.state.showAgentDialog}
                    onHide={this.toggleAgentModal}
                    dialogClassName="modal-90h"
                    //size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Agency + Agent</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ 'overflowX': 'scroll' }}>

                        <Form>
                        <Row>
                                <Form.Group as={Col} controlId="agencySearchString" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Search Agencies + Agents</Form.Label>
                               
                                        <InputGroup size="sm" >
                                            <Form.Control
                                                onChange={this.handleFormInputChange}
                                                value={this.state.agencySearchString}
                                                onKeyDown={this.handleEnterOnAgencySearch}
                                                as="input"
                                                type="text"
                                                placeholder="Search entities"
                                            />
                                            <InputGroup.Append><Button onClick={this.handleAgencySearch} variant="outline-secondary" size="sm">Search</Button></InputGroup.Append>
                                        </InputGroup>
                                       
                                                <Form.Check
                                                    checked={this.state.agencyInterstateFlag}
                                                    onChange={this.handleCheckBoxChange}
                                                    label="Search interstate"
                                                    type="checkbox"
                                                    name="agencyInterstateFlag"
                                                    onBlur={this.handleBlur}
                                                    
                                                />
                                                 </Form.Group>
                                                 <Col>
                                                 <Form.Label className="text-right"  sm={6} md={6} lg={1}>{" "}</Form.Label>
                                                 <a target="_blank" rel="noopener noreferrer" href={`/slmentities/new`}><Button variant="primary" type="button" size="sm" >Create New Agency</Button></a>{" "}
                                                 {this.state.entity_org_id && 
                                                 
                                                 <a target="_blank" rel="noopener noreferrer" href={`/slmentities/${this.state.entity_org_id}`}><Button variant="primary" type="button" size="sm" >Edit Agency </Button>{" "}</a>
                                                 }
                                                 {this.state.entity_org_id && 
                                                 <Button type="button" onClick={this.addAnotherRecord} variant="primary" size="sm"> Add Another Agency Link</Button>
                                                 
                                                 }
                                                 </Col>
                                                 
                    </Row>
                    <Row>
                                <Form.Group as={Col} controlId="entity_org_id" >          
                                <Form.Label className="text-right"  sm={6} md={6} lg={1}>Agency</Form.Label>                                
                                            <Select
                                                isClearable
                                                value={this.state.selectedAgency}
                                                onChange={this.handleAgencyChange}
                                                options={this.state.agencyOptions}
                                                onBlur={this.handleFormBlur}
                                                menuIsOpen={this.state.agencyMenuIsOpen}
                                            />
                                        


                                
                            </Form.Group>

                                <Form.Group as={Col} controlId="agency_phone" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Agency Phone</Form.Label>
                                    
                                        <Form.Control
                                        //onChange={this.handleFormInputChange}
                                            value={this.state.agency_phone}
                                            as="input"
                                            type="text"
                                            //onBlur={this.handleFormBlur}
                                            disabled
                                            readOnly
                                        />
                                   

                                </Form.Group>
                                
                                <Form.Group as={Col} controlId="agency_locale" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Suburb State Postcode</Form.Label>
                                   
                                        <Form.Control
                                        //onChange={this.handleFormInputChange}
                                            value={(this.state.agency_suburb||"")+" "+ (this.state.agency_state||"")+" "+(this.state.agency_postcode||"")}
                                            as="input"
                                            type="text"
                                            disabled
                                            readOnly
                                        //onBlur={this.handleFormBlur}
                                        />
                                   

                                </Form.Group>
                               


                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="entity_person_id" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Contact</Form.Label>
                                 
                                        
                                            <Select
                                                isClearable
                                                value={this.state.selectedAgent}
                                                onChange={this.handleAgentChange}
                                                options={this.state.agentOptions}
                                                onCreateOption={this.handleCreateAgentInputChange}
                                                onBlur={this.handleFormBlur}
                                            />
                                        
                                   
                                </Form.Group>
                                <Form.Group as={Col} controlId="agent_phone" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Contact Phone</Form.Label>
                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.agent_phone}
                                        as="input"
                                        type="text"
                                        onBlur={this.handleFormBlur}
                                        disabled
                                            readOnly
                                    />
                                </Form.Group>
                                
                                <Form.Group as={Col} controlId="agent_email" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Contact Email</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.agent_email}
                                        as="input"
                                        type="email"
                                        onBlur={this.handleFormBlur}
                                        disabled
                                        readOnly
                                    />


                                </Form.Group>
                            </Row>
                            <Row>
                            <Col>
                            {this.state.entity_person_id && <Button type="button" onClick={this.addContactRecord} variant="primary" size="sm"> Add Another Contact</Button>}
                            
                            </Col>
                            </Row>
                            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                            

                        </Form>
                </Modal.Body>
                </Modal>
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={this.state.tableRows}
                    pageSize={data.length}
                    showPagination={this.state.tableRows>5?true:false }
                    sortable={false}
                />
                </div>
            )
        }

    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        return [{}].concat(data).map(
            (d, i) =>                
                i !== 0
                    ? 
                    <ListGroup.Item key={i} as="a" header={d.name}>
                        {d.name}                 
                    </ListGroup.Item>                
                    : ""
        );
    }



    
    renderComponent() {
        return (
            <div className="agencies">
               
                 <Row className="show-Container">
                    <Col className="text-right" >
                    <a target="_blank" rel="noopener noreferrer" href={`/slmentities/new`}><Button variant="primary" type="button" size="sm" >Create New Agency</Button></a>{" "}
                         <Button variant="primary" size="sm" onClick={this.addRecord}>Add New Link</Button>

                    </Col>
                </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading ? this.props.controlType == "table2" ? this.renderTable2(this.props.data) : this.renderTable(this.props.data) : console.log("error")  }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="EntityLinkSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
